import React from 'react'
import NotificationCoverModel from '../../../../NotificationCoverModel'
import i18next from 'i18next'

const MemberInterDepTransferCover = ({ notification }) => {
  const lang = i18next.language
  const rtl = lang === 'ar'
  return (
    <NotificationCoverModel
      notification={notification}
      notifCoverContent={
        rtl
          ? `بقد تم نقلك الى قسم جديد`
          : 'You have been moved to a new Department'
      }
    />
  )
}

export default MemberInterDepTransferCover
